<template>
  <div class="editor-item overflow-visible">
    <editor-header
      :title="title"
      :helperReference="contentData.page_block_id"
      :hasHelper="contentData.has_helper"
    />
    <div class="editor-item__content" :class="[isVisible ? '' : 'hide']">
      <draggable-item
        v-model="contentData.items"
        :group="'subitems' + contentData.id"
        animation="300"
        handle=".sub__drag"
        @start="dragging = true"
        @end="dragging = false"
      >
        <div
          v-for="(item, subindex) in contentData.items"
          :key="subindex"
          :class="'editor-item__sub-container'"
          :dragStatus="dragging"
        >
          <color-list-item
            :item="item"
            :index="subindex"
            :key="item.number"
            v-on:deleteItem="deleteItem"
          />
        </div>
      </draggable-item>
      <hr
        v-if="contentData.items !== undefined && contentData.items.length > 0"
      />
      <add-brand-data-button
        @add-item="addCard"
        :title="$t('builder.add_color')"
      />
    </div>
  </div>
</template>

<script>
import colorListItem from './CardComponents/ColorListItem.vue'

export default {
  name: 'cardColorList',
  props: {
    contentItem: Object,
    dragStatus: Boolean
  },
  data () {
    return {
      unique_id: 1,
      isVisible: true
    }
  },
  created () {
    for (let i = 0; i < this.contentData.items.length; i++) {
      this.unique_id++
      this.contentData.items[i].number = this.unique_id
    }
  },
  methods: {
    addCard () {
      this.unique_id++
      this.contentData.items.push({
        title: '',
        hex: '000000',
        rgb: '255,255,255',
        cmyk: '',
        pantone: '',
        light_is_correct: '1',
        dark_is_correct: '0',
        number: this.unique_id
      })
    },
    deleteItem: function (index) {
      this.contentData.items.splice(index, 1)
    }
  },
  computed: {
    title: function () {
      if (this.contentItem._title) {
        return this.contentItem._title
      }
      return this.$t('builder.colors')
    },
    dragging: {
      get () {
        return this.dragStatus
      },
      set (val) {
        this.$emit('update:dragStatus', val)
      }
    },
    contentData: {
      get () {
        return this.contentItem
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  components: {
    colorListItem
  }
}
</script>

<style lang="scss" scoped>
hr {
  margin: 0;
  border-color: $ui-line-color;
}
</style>
